export default (state = { stores: [] }, action) => {
  switch (action.type) {
    case 'FETCH_STORE_SUGGESTIONS':
      return { ...state }
    case 'FETCH_STORE_SUGGESTIONS_SUCCESS':
      return { ...state, stores: action.payload.data }
    case 'FETCH_STORE_SUGGESTIONS_FAIL':
      return { ...state, error: action.error }
    default:
      return { ...state }
  }
}

export const Stores = storeSuggestion => {
  const {
    stores: { partnerShowcase }
  } = storeSuggestion

  const store = {
    stores: partnerShowcase || [],
    title: 'Encontre as suas lojas favoritas.',
    titleMobile: 'Lojas'
  }

  return store
}



// WEBPACK FOOTER //
// ./src/features/Suggestion/StoreSuggestion/reducer.js